<template>
	<div class="policyPublish">
		<div class="top">
			<a-tabs v-model="activeName">
				<a-tab-pane tab="政策发布" key="policyPublish"></a-tab-pane>
			</a-tabs>
			<div class="filter">
				<div class="filter_item">
					<a-button ghost type="primary" @click="goAddPolicy('')">
						<a-icon type="plus" />添加企业政策信息
					</a-button>
					<a-button type="primary" ghost style="margin-left: 10px" @click="showPolicyPush()">
						<a-icon type="plus" />政策推送
					</a-button>
					<div class="search_wrapper">
						<input type="text" class="search" v-model="content" @keyup.enter="onSearch"
							@input="onSearchChange" placeholder="请输入查询的标题/内容" />
						<svg-icon icon-class="search1" class="search_icon" @click.native="onSearch"></svg-icon>
					</div>
					<!-- <a-input-search class="inputSearch" placeholder="请输入查询的标题/内容" @search="onSearch" /> -->
				</div>
				<!-- <div class="filter_item">
					<span>政策类型：</span>
					<span class="option_item" @click="changePolicyType(item)" :class="{active:policyType_active == item.id}"
						v-for="(item,index) in policyType" :key="index + 'policyType'">{{item.name}}</span>
				</div> -->
				<div class="filter_item">
					<span>发布状态：</span>
					<span class="option_item" @click="changePublishStatus(item)"
						:class="{ active: publishStatus_active == item.id }" v-for="(item, index) in publishStatus"
						:key="index + 'publishStatus'">{{ item.name }}</span>
				</div>
				<div class="filter_item">
					<span>推送状态：</span>
					<span class="option_item" @click="changePublishPushStatus(item)"
						:class="{ active: publishPushStatus_active == item.id }"
						v-for="(item, index) in publishPushStatus"
						:key="index + 'publishPushStatus'">{{ item.name }}</span>
				</div>
				<!-- <div class="filter_item">
					<span>查看排序：</span>
					<span class="option_item" @click="changeBrowseNumSort(item)"
						:class="{active:browseNumSort_active == item.id}" v-for="(item,index) in browseNumSort"
						:key="index + 'browseNumSort'">{{item.name}}</span>
				</div> -->
				<div class="filter_item">
					<span>重复发布：</span>
					<span class="option_item" @click="changeRepeatPublish(item)"
						:class="{ active: repeatPublish_active == item.id }" v-for="(item, index) in repeatPublish"
						:key="index + 'repeatPublish'">{{ item.name }}</span>
				</div>
			</div>
		</div>

		<div style="height: 10px; background-color: #eff2f5"></div>
		<a-table class="table" :pagination="false" :row-selection="rowSelection" :columns="columns"
			:data-source="tableData" :scroll="{ x: 1000 }" rowKey="id" @change="handleTableChange">
			<div slot="status" slot-scope="text,record">
				<div v-if="text == 0">未发布</div>
				<div v-if="text == 1">
					延时发布
					<br/>
					{{record.publishTime}}
				</div>
				<div v-if="text == 2">发布</div>
			</div>
			<div slot="repeatPublish" slot-scope="text,record">
				{{ text }}
				<br/>
				{{text == '不重复'?'':record.latestRepeatTime}}
			</div>
			<div slot="action" slot-scope="text">
				<a v-if="text.state == 0" @click="goPublish(text)">发布</a>
				<a v-if="text.state != 0" @click="goPolicyDetail(text.id)">查看</a>
				<a @click="goAddPolicy(text.id)">编辑</a>
				<a @click="deletePolicy(text.id)">删除</a>
			</div>
		</a-table>
		<div class="down">
			<a-pagination class="pagination" :current="paginationConfig.current" :total="paginationConfig.total"
				show-size-changer show-quick-jumper @change="handlePageChange" @showSizeChange="onShowSizeChange" />
		</div>

		<a-modal :visible="visible" title="政策发布" :footer="null" @cancel="visible = false">
			<span class="enterprise">发布时间：</span>
			<a-radio-group v-model="value" @change="onRadioChange">
				<a-radio :value="1"> 立即发布 </a-radio>
				<a-radio :value="2"> 设置发布时间 </a-radio>
			</a-radio-group>
			<div class="row">
				<a-date-picker v-if="value == 2" value-format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"
					:disabled-time="disabledDateTime" :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
					v-model="delayTime" />
			</div>
			<div class="row">
				<a-button type="primary" @click="policyVisible = true">
					<a-icon type="plus" />推送企业设置
				</a-button>
				<a-button style="margin-left: 10px" type="primary" @click="handlePublish">
					<a-icon type="plus" />不推送企业,发布政策
				</a-button>
			</div>
		</a-modal>
		<policyPush :isPolicyPublish="true" v-if="policyVisible" ref="policyPush" :policyVisible.sync="policyVisible"
			:policyMessage="policyMessage" @refresh="getPolicyPublishList" @beforeOk="visible = false">
		</policyPush>
	</div>
</template>

<script>
	import policyPush from "@/components/policyPush";
	import moment from "moment";
	import {
		listPolicyPublish,
		delPolicyPublic,
		publishPolicy
	} from "@/api/policyPublish";
	export default {
		name: "policyPublish",
		components: {
			policyPush
		},
		computed: {
			rowSelection() {
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						this.policyMessage = [];
						//console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
						for (var i = 0; i < selectedRows.length; i++) {
							this.policyMessage.push({
								id: selectedRows[i].id,
								jobName: selectedRows[i].policyName,
								info: selectedRows[i].policyContent
							});
						}
						console.log(this.policyMessage);
					},
					getCheckboxProps: record => ({
						props: {
							disabled: record.name === "Disabled User", // Column configuration not to be checked
							name: record.name
						}
					})
				};
			}
		},
		mounted() {
			this.getPolicyPublishList();
		},
		data() {
			return {
				policyMessage: [],
				policyVisible: false,
				policyId: "",
				delayTime: "",
				value: 1,
				visible: false,
				content: "",
				postStatus: "",
				repeatMark: "",
				pushStatus: "",
				paginationConfig: {
					pageSize: 10,
					current: 1,
					total: 0,
					showQuickJumper: true, //显示跳转页数
					showSizeChanger: true, // 显示可改变每页数量
					pageSizeOptions: ["10", "20"], // 每页数量选项
					showTotal: total => `共 ${total} 条` //显示总数
				},

				activeName: "policyPublish",
				policyType: [{
						id: 0,
						name: "全部"
					},
					{
						id: 1,
						name: "资金政策"
					},
					{
						id: 2,
						name: "人才政策"
					},
					{
						id: 3,
						name: "园区政策"
					}
				],
				policyType_active: "0",
				publishStatus: [{
						id: null,
						name: "全部"
					},
					{
						id: 0,
						name: "未发布"
					},
					{
						id: 1,
						name: "延迟发布"
					},
					{
						id: 2,
						name: "已发布"
					}
				],
				publishPushStatus: [{
						id: null,
						name: "全部"
					},
					{
						id: 0,
						name: "未设置"
					},
					{
						id: 1,
						name: "部分企业"
					},
					{
						id: 2,
						name: "全部企业"
					}
				],
				publishStatus_active: null,
				publishPushStatus_active: null,
				browseNumSort: [{
						id: 0,
						name: "全部"
					},
					{
						id: 1,
						name: "升序"
					},
					{
						id: 2,
						name: "降序"
					}
				],
				browseNumSort_active: "0",
				repeatPublish: [{
						id: null,
						name: "全部"
					},
					{
						id: "不重复",
						name: "不重复"
					},
					{
						id: "每周一",
						name: "每周一"
					},
					{
						id: "每周二",
						name: "每周二"
					},
					{
						id: "每周三",
						name: "每周三"
					},
					{
						id: "每周四",
						name: "每周四"
					},

					{
						id: "每周五",
						name: "每周五"
					},
					{
						id: "每周六",
						name: "每周六"
					},
					{
						id: "每周日",
						name: "每周日"
					},
					{
						id: "每月第一天",
						name: "每月第一天"
					},
					{
						id: "每月15号",
						name: "每月15号"
					},
					{
						id: "每月最后一天",
						name: "每月最后一天"
					}
				],
				repeatPublish_active: null,

				columns: [{
						title: "序号",
						customRender: (text, record, index) => `${index + 1}`,
						align: "center",
						fixed: "left",
						width: 60
					},
					{
						title: "政策名称",
						dataIndex: "policyName",
						key: "policyName",
						width: 450
					},
					{
						title: "申报日期",
						dataIndex: "applyStartTime",
						key: "applyStartTime",
						align: "center",
						width: 120
					},
					{
						title: "发布",
						dataIndex: "state",
						key: "state",
						align: "center",
						width: 120,
						scopedSlots: {
							customRender: "status"
						}
					},
					{
						title: "查看",
						dataIndex: "readCount",
						key: "readCount",
						align: "center",
						width: 80,
						sorter: (a, b) => a.readCount - b.readCount
					},
					// {
					//   title: "收藏",
					//   dataIndex: "collectCount",
					//   key: "collectCount",
					//   align: "center",
					//   width: 100,
					//   sorter: (a, b) => a.collectCount - b.collectCount,
					// },
					{
						title: "分享",
						dataIndex: "shareCount",
						key: "shareCount",
						align: "center",
						width: 80,
						sorter: (a, b) => a.shareCount - b.shareCount
					},
					{
						title: "重复发布",
						dataIndex: "repeatMark",
						key: "repeatMark",
						align: "center",
						width: 120,
						scopedSlots: {
							customRender: "repeatPublish"
						}
					},
					{
						title: "操作",
						fixed: "right",
						align: "left",
						width: 150,
						scopedSlots: {
							customRender: "action"
						}
					}
				],
				tableData: []
			};
		},
		methods: {
			showPolicyPush() {
				if (this.policyMessage.length > 0) {
					this.policyVisible = true;
				} else {
					this.$message.info("请勾选需推送的政策");
				}
			},
			goPolicyDetail(id) {
				this.$router.push({
					path: "/policyDetail",
					query: {
						targetId: id
					}
				});
			},
			goPublish(text) {
				this.policyMessage = [];
				this.policyId = text.id;
				this.visible = true;
				this.policyMessage.push({
					id: text.id,
					jobName: text.policyName,
					info: text.policyContent
				});
			},
			handlePublish() {
				if(this.value == 2&& !this.delayTime){
					this.$message.info('请选择发布时间')
				}else{
					this.visible = false;
					this.goPublishPolicy();
				}
			},
			onRadioChange(e) {
				console.log("radio checked", e.target.value);
			},
			moment,
			range(start, end) {
				const result = [];
				for (let i = start; i < end; i++) {
					result.push(i);
				}
				return result;
			},

			disabledDate(current) {
				// Can not select days before today and today
				// return current && current < moment().endOf('day');
				// Can not select days before today
				return current < moment().subtract(1, "day");
			},

			disabledDateTime() {
				/* return {
					disabledHours: () => this.range(0, 24).splice(4, 20),
					disabledMinutes: () => this.range(30, 60),
					disabledSeconds: () => [55, 56],
				}; */
			},

			deletePolicy(id) {
				let param = {
					id: id
				};
				delPolicyPublic(param).then(() => {
					this.$message.success("删除成功");
					this.getPolicyPublishList();
				});
			},
			goPublishPolicy() {
				let params = {
					delayTime: this.delayTime,
					id: this.policyId,
					pushType: this.value
				};
				publishPolicy(params).then(res => {
					this.$message.success(res.data);
					this.getPolicyPublishList();
				});
			},
			goAddPolicy(id) {
				if (id) {
					this.$router.push({
						path: "/addPolicy",
						query: {
							id: id
						}
					});
				} else {
					this.$router.push({
						path: "/addPolicy"
					});
				}
			},
			onSearch() {
				this.getPolicyPublishList();
			},
			onSearchChange() {
				if (!this.content) {
					this.getPolicyPublishList();
				}
			},
			changePolicyType(item) {
				this.policyType_active = item.id;
			},
			changePublishStatus(item) {
				this.paginationConfig.current = 1
				this.publishStatus_active = item.id;
				for (let item of this.publishStatus) {
					if (item.id == this.publishStatus_active) {
						this.postStatus = item.id;
						if (this.publishStatus_active == null) {
							this.postStatus = "";
						}
					}
				}
				this.getPolicyPublishList();
			},
			changePublishPushStatus(item) {
				this.paginationConfig.current = 1
				this.publishPushStatus_active = item.id;
				for (let item of this.publishStatus) {
					if (item.id == this.publishPushStatus_active) {
						this.pushStatus = item.id;
						if (this.publishPushStatus_active == null) {
							this.pushStatus = "";
						}
					}
				}
				this.getPolicyPublishList();
			},
			changeRepeatPublish(item) {
				this.paginationConfig.current = 1
				this.repeatPublish_active = item.id;
				for (let item of this.repeatPublish) {
					if (item.id == this.repeatPublish_active) {
						this.repeatMark = item.name;
						if (this.repeatPublish_active == null) {
							this.repeatMark = "";
						}
					}
				}
				this.getPolicyPublishList();
			},
			changeBrowseNumSort(item) {
				this.browseNumSort_active = item.id;
			},
			handleTableChange(pagination, filters, sorter) {
				console.log("params", pagination, filters, sorter);
			},
			handlePageChange(page, pageSize) {
				this.paginationConfig.current = page;
				this.paginationConfig.pageSize = pageSize;
				this.getPolicyPublishList();
			},
			onShowSizeChange(current, pageSize) {
				this.paginationConfig.current = current;
				this.paginationConfig.pageSize = pageSize;
				this.getPolicyPublishList();
			},
			getPolicyPublishList() {
				let params = {
					beginTime: "",
					content: this.content,
					endTime: "",
					order: 0,
					pageNum: this.paginationConfig.current,
					pageSize: this.paginationConfig.pageSize,
					policyCategory: null,
					postStatus: this.postStatus,
					repeatMark: this.repeatMark,
					pushStatus: this.pushStatus
				};
				listPolicyPublish(params).then(res => {
					console.log(res);
					this.tableData = res.data.list.map(el => {
						el.applyStartTime = el.applyStartTime.substr(0, 10);
						return el;
					});
					this.paginationConfig.current = res.data.pageNum;
					this.paginationConfig.pageSize = res.data.pageSize;
					this.paginationConfig.total = res.data.total;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.policyPublish {
		.top {
			background-color: #fff;
			padding: 0 20px 1px;

			::v-deep .ant-tabs-tab-active {
				font-weight: 500;
				color: #333;
				font-size: 16px;
				padding: 12px 0;
			}

			::v-deep .ant-tabs-bar {
				margin: 0 0 20px 0;
			}

			::v-deep .ant-tabs-ink-bar {
				width: 64px;
			}

			.filter {
				.filter_item {
					margin-bottom: 20px;

					::v-deep .ant-btn-background-ghost.ant-btn-primary {
						color: #0072f7;
						border-color: #0072F7;
					}

					.search_wrapper {
						display: -webkit-box;
						float: right;

						.search {
							width: 300px;
							height: 32px;
							padding-left: 10px;
							padding-right: 28px;
							margin-left: 24px;
							background: #ffffff;
							border-radius: 2px;
							border: 1px solid #e0e0e0;
							font-size: 14px;
							font-weight: 400;
							outline: none;
						}

						.search:focus{
							border-color: #0072f7;
						}

						.search::-webkit-input-placeholder {
							color: #dddddd;
						}

						.search::-ms-input-placeholder {
							color: #dddddd;
						}

						.search::-moz-placeholder {
							color: #dddddd;
						}

						.search_icon {
							width: 14px;
							height: 14px;
							margin-top: 0px;
							margin-left: -28px;
							color: #0072f7;
							cursor: pointer;
						}
					}

					::v-deep .ant-input-search-icon {
						color: #0072f7;
					}

					.inputSearch {
						width: 300px;
						float: right;
					}

					span {
						font-size: 14px;
						font-weight: 400;
					}

					span:nth-child(2) {
						margin-left: 10px;
					}

					.option_item {
						margin-right: 10px;
						padding: 5px 10px;
						cursor: pointer;
					}

					.active {
						height: 24px;
						line-height: 24px;
						background: #0072f7;
						border-radius: 4px;
						color: #fff;
					}

					.ant-btn:hover {
						background: #0072f7 !important;
						color: #fff;
					}
				}
			}
		}

		.table {
			padding: 20px 20px 0;
			background-color: #ffffff;

			a {
				margin-right: 10px;
				color: #0072f7;

				&:hover {
					color: #59A4FF;
					text-decoration: none;
				}
			}
		}

		::v-deep .ant-table-thead > tr > th{
			padding: 9px 16px;
		}

		::v-deep .ant-table-tbody > tr > td{
			padding: 24px 16px;
		}

		::v-deep .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on,
		::v-deep .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on{
			color: #0072f7;
		}

		.down {
			background-color: #ffffff;
			height: 72px;

			.pagination {
				margin: 20px;
				float: right;
			}
		}
	}

	::v-deep .ant-modal-content {
		.ant-modal-body {
			.row {
				text-align: center;
				margin-top: 20px;
			}
		}
	}
</style>
